module.exports = "/_next/static/images/calendar-068e35f516f41d7be2854b3be63e6c29.svg";